module.exports = __webpack_public_path__ + "img/kubiqa-logo.d3e989c3.svg";